<template>
    <div class="content">
        <div class="bg">
            <div v-if="bgimage" class="bgimage" v-bind:style="{ backgroundImage: 'url(' + bgimage + ')' }">
            </div>
            <div v-else-if="bgvideo" class="bgvideo">
                <video class="bgvideo" autoplay playsinline muted loop ref="video">
                    <source :src="bgvideo" type="video/mp4">
                </video>
            </div>
        </div>
        <div class="container mx-auto">
            <div class="row">
                <div class="col-sm-12 col-md-6 my-3">
                    <Title class="mb-4 title text-white" v-if="title" v-bind:title="title" :main="true"></Title>
                    <div class="text-white">
                        <p v-if="text" v-html="text"></p>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 my-3 relative">
                    <div class="imgtext__box">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="494" height="407" viewBox="0 0 494 407">
                            <defs>
                            <rect v-bind:id="'rectangle-a' + id" width="494" height="407" x="109" y="1757"/>
                            <mask v-bind:id="'rectangle-b' + id" width="494" height="407" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                                <use class="mask" stroke-dasharray="5" stroke-width="2" v-bind:xlink:href="'#rectangle-a' + id"/>
                            </mask>
                            </defs>
                            <use fill="none" fill-rule="evenodd" 
                            stroke="#D10A1C" stroke-dasharray="5" stroke-width="2" v-bind:mask="'url(#rectangle-b' + id +')'" transform="translate(-109 -1757)" v-bind:xlink:href="'#rectangle-a' + id"/>
                        </svg>
                    </div>
                    <div class="imgtext__imgcontainer">
                        <div class="imgtext__img">
                            <div v-if="images" ref="gallery" class="imgtext__img">
                                <img v-for="img in images" v-bind:key="img" v-bind:src="img"  />
                            </div>
                        </div>
                    </div>

                    <div v-if="video" class="video">
                        <video class="imgtext__video" autoplay playsinline muted loop ref="video">
                            <source :src="video" type="video/mp4">
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Title from '@/components/Title';
import { tns } from "tiny-slider/src/tiny-slider"

export default {
    name: 'contenuto',
    components: {
        Title
    },
    props: {
        bgimage: String,
        bgvideo: String,
        title: String,
        text: String,
        images: Array,
        video: String
    },
    data() {
        return {
            id: 'pp'
        }
    },
    mounted() {
        
        if (this.$refs.gallery && this.$refs.gallery.querySelectorAll('img').length > 1) {
            let slider = tns({
            container: this.$refs.gallery,
            items: 1,
            autoplay: true,
            controls: false,
            nav: false,
            autoplayButton: false
            });
        }
    },
    deactivated() {
        console.log('unmounted')
    }
}
</script>

<style scoped lang="scss">
.content {
    @include media-breakpoint-down(sm) {
        // position: relative;
    }
}
.container {
    position: relative;
    z-index: 2;
}
.bgimage {
    background-repeat: no-repeat;
    background-size: cover;
}
.bg {
    position: fixed;
    width: 100%;
    height: calc(100% + 120px);
    top: -120px;
    @include media-breakpoint-up(md) {
        height: calc(100% + 220px);
        top: -220px;
    }

    
    left: 0;
    z-index: -1;
    video,
    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
    &:after {
        content: '';
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        display: block;
        background: linear-gradient(358.96deg, #000000 0.94%, rgba(0, 0, 0, 0) 99.17%);
        width: 100%;
        height: 100%;
    }
    > div {
        position: relative;
        z-index: 0;
    }
    .bgimage,
    .bgvideo {
        height: 100%;
        width: 100%;
    }
}
.title /deep/ h1 {
    @include media-breakpoint-up(lg) {
        font-size: 80px;
    }
}

img,
video {
    max-width: 100%;
}
.imgtext__box {
  position: absolute;
  z-index: 0;
  height: 86%;
  width: 100%;

    @include media-breakpoint-down(md) {
        display: none;
    }

  svg {

    max-width: 100%;
    display: block;
    margin-top: auto;
    margin-left: auto;
  }
  right: -9%;

  bottom: -8%;
}
.imgtext__box ~ div {
    position: relative;
    z-index: 2;
}

.imgtext__imgcontainer {
  img {
    position: relative;
    z-index: 2;
  }
  @include media-breakpoint-down(sm) {
    overflow: hidden;
  }
}

.imgtext__img {
  overflow: hidden;
  position: relative;
}
</style>
